import { OrgData } from "@p0security/shared/types/tenant/index";
import { PropsWithChildren } from "react";

import { useCustomOidcAuth } from "../hooks/useCustomOidcAuth";
import { Tenant } from "../types/auth";
import { UserAuthContext } from "./UserAuthProvider";

type Props = {
  tenant: Tenant;
  orgData: OrgData | undefined;
  orgSlug: string | undefined;
};

export const OidcUserProvider: React.FC<PropsWithChildren<Props>> = ({
  children,
  tenant,
  orgData,
  orgSlug,
}) => {
  const auth = useCustomOidcAuth(tenant, orgData, orgSlug);

  return (
    <UserAuthContext.Provider value={auth}>{children}</UserAuthContext.Provider>
  );
};
